const ARemployeeDataSelector = ({ empployeeUpdate: { ARemployeeData } }) =>
  ARemployeeData;

export default ARemployeeDataSelector;
